export const extendedRegExp = /[|^€{}~\\[\]]/g;
export const unicodeRegExp = /[^\x0a\x0d\x20-\x5F\x61-\x7E¡£¤¥§¿ÄÅÆÇÉÑÖØÜßàäåæèéìñòöøùüΓΔΘΛΞΠΣΦΨΩ€]/; // eslint-disable-line no-control-regex
